import { render } from "./DailyTransaction.vue?vue&type=template&id=07964ee8&scoped=true"
import script from "./DailyTransaction.vue?vue&type=script&lang=js"
export * from "./DailyTransaction.vue?vue&type=script&lang=js"

import "./DailyTransaction.vue?vue&type=style&index=0&id=07964ee8&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07964ee8"]])

export default __exports__